export default errors => {
  return errors.count > 0;
};
